// extracted by mini-css-extract-plugin
export var icon = "_re-0";